module.exports = __webpack_public_path__ + "static/media/Поломанный.cf775a46.jpg";